import { ErrorHandlerService } from '@y42/error-handling';
import { AbstractFeatureStoreModel } from '@y42/feature';
import { Y42GitFolders, Y42GitPath } from '@y42/feature/git';
import { AbstractGitEntityState, AbstractGitEntityStore } from '@y42/feature/git/state';
import { Y42RouterService, Y42Routes } from '@y42/feature/routing';
import { GitQuery } from '@y42/git';
import {
  AbstractJobCancelationService,
  AbstractJobService,
  JobContextService,
  JobHttpModel,
  JobHttpService,
  JobQuery,
  JobStore,
  JobTriggerService,
  TableStoreModel,
} from '@y42/job';
import { Observable } from 'rxjs';

export abstract class DatasourceTableJobService<
  HttpModel extends JobHttpModel = JobHttpModel,
> extends AbstractJobService<HttpModel> {
  constructor(
    triggerService: JobTriggerService,
    parentStore: AbstractGitEntityStore<AbstractGitEntityState<TableStoreModel>>,
    jobStore: JobStore,
    jobQuery: JobQuery,
    jobContext: JobContextService,
    gitQuery: GitQuery,
    errorHandlerService: ErrorHandlerService,
    httpService: JobHttpService<HttpModel>,
    gitRootPath: Y42GitPath<Y42GitFolders>,
    featureRoute: Y42Routes,
    routerService: Y42RouterService,
    grandParentLoading$: Observable<boolean>,
    grandParentId$: Observable<AbstractFeatureStoreModel['$path'] | null | undefined>,
    jobCancelationService?: AbstractJobCancelationService,
  ) {
    super(
      triggerService,
      parentStore,
      jobStore,
      jobQuery,
      jobContext,
      gitQuery,
      errorHandlerService,
      httpService,
      gitRootPath,
      featureRoute,
      routerService,
      grandParentLoading$,
      grandParentId$,
      jobCancelationService,
    );
  }

  readonly parentType = 'table';
}
